<template>
  <!-- PSG解析受付 -->
  <div id="PSGRequestAccept">
    <div id="container">
      <psgNavi v-bind:pageid='"PSGRequestAccept"'></psgNavi>
      <div class="labelTitle lable">PSG解析 受付</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
              <option></option>
              <option value="1">フルPSG検査</option>
              <option value="2">簡易検査</option>
              <option value="3">睡眠検査機器配送ｻｰﾋﾞｽ</option>
              </select></td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
              <option></option>
              <option value="false">含まない</option>
              <option value="true">デモのみ</option>
              </select></td>
            <th>解析方法</th>
            <td><select v-model="searchConditions.analysisMethod">
              <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
              <!-- <option></option>
              <option>標準マニュアル解析(Aliceシリーズ)</option>
              <option>Expert Review解析(Aliceシリーズ)</option>
              <option>スリーププロファイラー解析</option>
              <option>簡易検査 スマートウォッチ</option>
              <option>簡易検査 Aliceシリーズ</option>
              <option>簡易検査 ウォッチパット</option> -->
            </select></td>
          </tr>
          <tr>
            <th style="font-size: 10px">いびきセンサー</th>
            <td><select v-model="searchConditions.snoreSensor">
              <option></option>
              <option value="1">無</option>
              <option value="2">有</option>
            </select></td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client" maxlength="256"/></td>            
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName" maxlength="100"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" v-model="searchConditions.applicationDateEnd"/></td>
            <th>返却希望日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.returnDateStart"/> ～ <input type="date" v-model="searchConditions.returnDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
          id="psgRequestAcceptTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="applicationDate"
          default-sort-direction="asc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="100" sortable centered>
              <router-link :to="{name:'PSGRequestAcceptDetail', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column field="applicationDate" label="申込日" width="120" sortable centered>
              {{props.row.applicationDate }}
            </b-table-column>
            <b-table-column field="returnDate" label="返却希望日" width="110" sortable centered >
              {{props.row.returnDate }}<span v-if="props.row.urgent" class="urgent" />
            </b-table-column>
            <b-table-column field="inspectionKind" label="種別" width="100" sortable>
              {{props.row.inspectionKind}}<span v-if="props.row.demo" class="demo" />
            </b-table-column>
            <b-table-column field="analysisMethod" label="解析方法" width="200" sortable >
              {{props.row.analysisMethod | analysisMethodFilter(analysisMethodList)}}
            </b-table-column>
            <b-table-column field="snoreSensor" label="いびきセンサー" width="90" sortable >
              {{props.row.snoreSensor | snoreSensorFilter()}}
            </b-table-column>
            <b-table-column field="client" label="依頼元" width="200" sortable >
              {{props.row.client}}
            </b-table-column>
            <b-table-column field="hospital" label="医療機関" width="200" sortable >
              {{props.row.hospital}}
            </b-table-column>
            <b-table-column field="patientName" label="患者名" width="150" sortable >
              {{props.row.patientName}}
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/psg/PSGNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "PSGRequestAccept",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getPsgRequestListPOST;
      var successCallBack = this.getPsgRequestListPOSTSuccess;
      var errorCallBack = this.getPsgRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPsgRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalPsg.getPsgRequestListPOST({
        body:obj
      });
    },
    getPsgRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getPsgRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.psgMethod, false);
      this.analysisMethodList.unshift({})
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    return {
      searchConditions:{
        receiptNumber:"",
        kind:"",
        demo:"",
        analysisMethod:"",
        client:"",
        hospital:"",
        patientName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        returnDateStart:"",
        returnDateEnd:"",
        snoreSensor:"",
      },
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList:[],
      takeOverSearchParams,
      hasResult: false
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    analysisMethodFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },
    snoreSensorFilter(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  components: {
    psgNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/psg/PSGRequestAccept.vue